import { useEffect, useMemo, useState } from "react";
import Modal from "../../components/Modal";
import useLedger from "../../hooks/useLedger";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PaginationButtons from "../../components/PaginationButtons";
import { ChevronLeft } from "lucide-react";
const PartyManagement = () => {

    const [isModalOpen, setModalOpen] = useState(false);
    const [partiesLoading, setPartiesLoading] = useState(false);
    const { loading, getAllParties, addParty } = useLedger();


    const [PartiesList, setPartiesList] = useState([]);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [partiesPerPage, setPartiesPerPage] = useState(10);

    const [formParty, setParties] = useState({
        name: '',
        contactNumber: '',
        category: '',
        address: '',
        //bank details
        bankDetails: []
    })
    const fetchParties = async () => {
        setPartiesLoading(true);
        try {
            const data = await getAllParties();
            if (data) {
                console.log("API Data Received:", data);
                setPartiesList(data);
            }
        } catch (error) {
            console.error("Error fetching parties:", error);
        } finally {
            setPartiesLoading(false);
        }
    };
    useEffect(() => {
        fetchParties();
    }, []);

    const handleChange = (e) => {
        const name = e.target.name;
        setParties((prev) => ({ ...prev, [name]: e.target.value }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setPartiesLoading(true);
        try {
            const newData = await addParty(formParty);
            console.log(newData);
            setPartiesList((prev) => ([newData.data, ...prev]))
            toast.success(newData.message);
            setModalOpen(false);
            setParties({
                name: '',
                contactNumber: '',
                category: '',
                address: '',
                bankDetails: []
            });
        } catch (err) {
            console.log(err);
            toast.error(err.message);
        } finally {
            setPartiesLoading(false);
        }
    }

    const { filterdParty } = useMemo(() => {
        let filterdParty = PartiesList || [];
        let filterSearch = searchTerm.toLowerCase();

        if (searchTerm) {
            filterdParty = filterdParty.filter(party => {

                const nameMatch = party.name.toLowerCase().includes(filterSearch);
                const addressMatch = party.address.toLowerCase().includes(filterSearch);

                let contactMatch = false;
                if (party.contactNumber) {
                    contactMatch = String(party.contactNumber).toLowerCase().includes(filterSearch);
                }

                return nameMatch || addressMatch || contactMatch;
            });
        }

        return {
            filterdParty
        }

    }, [PartiesList, searchTerm])

    const { totalParties, currentParties } = useMemo(() => {
        const totalParties = filterdParty.length;
        const lastIndex = currentPage * partiesPerPage;
        const firstIndex = lastIndex - partiesPerPage;

        const currentParties = filterdParty.slice(firstIndex, lastIndex);
        return {
            totalParties,
            currentParties
        }
    }, [filterdParty, currentPage, partiesPerPage]);
    return (
        <div className="w-full">
            {/* ... (Back Button Removed - Sidebar handles navigation) ... */}
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="flex flex-col  md:flex-row justify-between items-center mb-6">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-800">Parties Management</h1>
                        <p className="text-gray-500 text-sm mt-1">Manage your suppliers and vendors</p>
                    </div>

                    {/* Add Party Button */}
                    <button
                        onClick={() => {
                            setParties({
                                name: '',
                                contactNumber: '',
                                category: '',
                                address: '',
                                bankDetails: []
                            });
                            setModalOpen(true)
                        }}
                        className="mt-4 md:mt-0 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm transition-all flex items-center gap-2">
                        <span>+</span> Add Party
                    </button>
                </div>

                <div className="space-y-4">
                    <div className='flex justify-between items-center'>
                        <h1 className='text-2xl font-semibold text-gray-700'>Parties List 📋</h1>
                        <div className='flex items-center gap-3 text-gray-600 border border-gray-100 shadow-sm rounded-sm p-1'>
                            <p className='text-sm'>Parties per page</p>
                            <select name="noOfBills"
                                onChange={(e) => setPartiesPerPage(Number(e.target.value))}
                            >
                                <option value='10'>10</option>
                                <option value='5'>5</option>
                                <option value='15'>15</option>
                                <option value='20'>20</option>
                                <option value={totalParties}>All</option>

                            </select>
                        </div>
                    </div>

                    {/* --- FILTER & SEARCH BAR --- */}
                    <div className="bg-white p-4 rounded-t-xl shadow-sm border border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">

                        {/* Search Bar (Left) */}
                        <div className="w-full md:w-1/3">
                            <input
                                type="text"
                                placeholder="Search by Name , contact Number or Note..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-blue-100 outline-none transition-all"
                            />
                        </div>

                    </div>

                </div>

                {/* Table Container */}
                <div className="bg-white shadow-sm rounded-b-xl border border-gray-200 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full text-center border-collapse">

                            {/* Table Head */}
                            <thead className="bg-gray-50 border-b border-gray-200">
                                <tr>
                                    <th className="py-4 px-6 text-xs font-bold uppercase tracking-wider text-gray-500">SR.NO</th>
                                    <th className="py-4 px-6 text-xs font-bold uppercase tracking-wider text-gray-500">Name</th>
                                    <th className="py-4 px-6 text-xs font-bold uppercase tracking-wider text-gray-500">Contact Number</th>
                                    <th className="py-4 px-6 text-xs font-bold uppercase tracking-wider text-gray-500">Category</th>
                                    <th className="py-4 px-6 text-xs font-bold uppercase tracking-wider text-gray-500">Address</th>
                                    <th className="py-4 px-6 text-xs font-bold uppercase tracking-wider text-gray-500">Actions</th>
                                </tr>
                            </thead>

                            {/* Table Body */}
                            <tbody className="divide-y divide-gray-100">
                                {partiesLoading ? (
                                    <tr>
                                        <td colSpan="6" className="py-8 text-center">
                                            <div className="flex justify-center">
                                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
                                            </div>
                                            <p className="text-gray-400 mt-2 text-sm">Loading parties...</p>
                                        </td>
                                    </tr>
                                ) : (
                                    // 🛑 CORRECT LOGIC START: If not loading, check if list is empty 🛑
                                    filterdParty.length === 0 ?
                                        (
                                            <tr>
                                                {/* Ensure colSpan matches the number of columns (6) */}
                                                <td colSpan="6" className="py-10 text-center text-gray-400 italic">
                                                    No Parties found
                                                </td>
                                            </tr>
                                        ) : (
                                            // 🛑 MAPPING LOGIC: Render rows if parties exist 🛑
                                            currentParties.map((party, index) => (
                                                <tr key={party.id} className="hover:bg-gray-50 transition-colors group">
                                                    {/* seNO */}
                                                    <td className="py-2 px-6">
                                                        <p className="font-semibold text-gray-800">{index + 1}</p>
                                                    </td>
                                                    <td className="py-4 px-6">
                                                        <div className="flex flex-col items-start gap-1">
                                                            <p className="font-semibold text-gray-800">{party.name}</p>

                                                        </div>
                                                    </td>

                                                    {/* Contact */}
                                                    <td className="py-4 px-6 text-gray-600 font-medium whitespace-nowrap">
                                                        {party.contactNumber}
                                                    </td>

                                                    {/* Category - with a pill badge style */}
                                                    <td className="py-4 px-6">
                                                        <span className="bg-gray-100 text-gray-600 py-1 px-3 rounded-full text-xs font-semibold border border-gray-200">
                                                            {party.category || "-"}
                                                        </span>
                                                    </td>

                                                    {/* Address */}
                                                    <td className="py-4 px-6 text-gray-500 text-sm max-w-xs truncate">
                                                        {party.address || "-"}
                                                    </td>

                                                    {/* Action Button */}
                                                    <td className="py-4 px-6 text-right">
                                                        <button
                                                            onClick={() => navigate(`bills/${party._id}`)}
                                                            className="text-sm font-semibold text-gray-600 hover:text-black border border-gray-300 hover:border-black px-4 py-1.5 rounded-lg transition-all bg-white">
                                                            View Details
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                )}
                            </tbody>
                        </table>
                        <PaginationButtons
                            totalRecord={totalParties}
                            recordPerPage={partiesPerPage}
                            currentPage={currentPage}
                            setCurrentPage={(page) => setCurrentPage(page)}
                            setNextPage={() => setCurrentPage((prev) => (Math.min(totalParties, prev + 1)))}
                            setPrevPage={() => setCurrentPage((prev) => (Math.max(1, prev - 1)))}
                        />
                    </div>
                </div>

                {isModalOpen && (
                    <Modal
                        title={'Add New Party'}
                        isOpen={true}
                        onClose={() => setModalOpen(false)}
                    >
                        <form onSubmit={handleSubmit} className="space-y-5">

                            {/* --- SECTION 1: BASIC DETAILS --- */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                {/* Name */}
                                <div className="flex flex-col gap-1">
                                    <label className="text-sm font-semibold text-gray-700">Party Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formParty.name}
                                        onChange={handleChange}
                                        placeholder="e.g. Pavitra Traders"
                                        className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-gray-200 focus:border-gray-500 outline-none transition-all"
                                        required
                                    />
                                </div>

                                {/* Contact Number */}
                                <div className="flex flex-col gap-1">
                                    <label className="text-sm font-semibold text-gray-700">Contact Number <span className="text-red-500">*</span></label>
                                    <input
                                        type="tel"
                                        name="contactNumber"
                                        value={formParty.contactNumber}
                                        onChange={handleChange}
                                        placeholder="e.g. 9890012345"
                                        className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-gray-200 focus:border-gray-500 outline-none transition-all"
                                        required
                                    />
                                </div>

                                {/* Category */}
                                <div className="flex flex-col gap-1">
                                    <label className="text-sm font-semibold text-gray-700">Category </label>
                                    <input type="text" name="category"
                                        placeholder="eg. Garments"
                                        value={formParty.category}
                                        onChange={handleChange}
                                        className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-gray-200 focus:border-gray-500 outline-none transition-all resize-none"

                                    />
                                </div>

                                {/* Address (Full Width) */}
                                <div className="flex flex-col gap-1 md:col-span-2">
                                    <label className="text-sm font-semibold text-gray-700">Address</label>
                                    <textarea
                                        name="address"
                                        value={formParty.address}
                                        onChange={handleChange}
                                        rows="2"
                                        placeholder="Shop No, Area, City..."
                                        className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-gray-200 focus:border-gray-500 outline-none transition-all resize-none"
                                    ></textarea>
                                </div>
                            </div>

                            {/* --- SECTION 2: BANK DETAILS (Optional & Multiple) --- */}
                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                                <div className="flex justify-between items-center mb-3">
                                    <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider">
                                        Bank Details (Optional)
                                    </h3>
                                    <button
                                        type="button"
                                        onClick={() => setParties(prev => ({
                                            ...prev,
                                            bankDetails: [...(prev.bankDetails || []), { bankName: '', accountNumber: '', ifsc: '' }]
                                        }))}
                                        className="text-xs flex items-center gap-1 bg-white border border-gray-200 px-2 py-1 rounded shadow-sm hover:bg-gray-50 text-blue-600 font-semibold"
                                    >
                                        <span>+ Add Bank</span>
                                    </button>
                                </div>

                                <div className="space-y-4">
                                    {(!formParty.bankDetails || formParty.bankDetails.length === 0) && (
                                        <div className="text-center py-4 text-gray-400 text-sm italic border border-dashed border-gray-200 rounded-lg">
                                            No bank details added. Click "+ Add Bank" to add.
                                        </div>
                                    )}

                                    {formParty.bankDetails?.map((bank, index) => (
                                        <div key={index} className="relative grid grid-cols-1 md:grid-cols-2 gap-4 p-3 bg-white rounded-lg border border-gray-200 shadow-sm animate-in fade-in slide-in-from-top-2">

                                            {/* Remove Button */}
                                            {formParty.bankDetails.length > 0 && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const newBanks = formParty.bankDetails.filter((_, i) => i !== index);
                                                        setParties(prev => ({ ...prev, bankDetails: newBanks }));
                                                    }}
                                                    className="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full p-1 hover:bg-red-200 transition-colors shadow-sm"
                                                    title="Remove Bank"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 18 18" /></svg>
                                                </button>
                                            )}

                                            {/* Bank Name */}
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-medium text-gray-600">Bank Name <span className="text-red-500">*</span></label>
                                                <input
                                                    type="text"
                                                    value={bank.bankName}
                                                    onChange={(e) => {
                                                        const newBanks = [...formParty.bankDetails];
                                                        newBanks[index].bankName = e.target.value;
                                                        setParties(prev => ({ ...prev, bankDetails: newBanks }));
                                                    }}
                                                    placeholder="e.g. HDFC Bank"
                                                    className="text-sm border border-gray-200 rounded-lg px-3 py-2 focus:ring-1 focus:ring-blue-100 focus:border-blue-400 outline-none"
                                                    required
                                                />
                                            </div>

                                            {/* IFSC Code */}
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-medium text-gray-600">IFSC Code <span className="text-red-500">*</span></label>
                                                <input
                                                    type="text"
                                                    value={bank.ifsc}
                                                    onChange={(e) => {
                                                        const newBanks = [...formParty.bankDetails];
                                                        newBanks[index].ifsc = e.target.value;
                                                        setParties(prev => ({ ...prev, bankDetails: newBanks }));
                                                    }}
                                                    placeholder="e.g. HDFC000123"
                                                    className="text-sm border border-gray-200 rounded-lg px-3 py-2 focus:ring-1 focus:ring-blue-100 focus:border-blue-400 outline-none uppercase"
                                                    required
                                                />
                                            </div>

                                            {/* Account Number (Full Width in Box) */}
                                            <div className="flex flex-col gap-1 md:col-span-2">
                                                <label className="text-xs font-medium text-gray-600">Account Number <span className="text-red-500">*</span></label>
                                                <input
                                                    type="text"
                                                    value={bank.accountNumber}
                                                    onChange={(e) => {
                                                        const newBanks = [...formParty.bankDetails];
                                                        newBanks[index].accountNumber = e.target.value;
                                                        setParties(prev => ({ ...prev, bankDetails: newBanks }));
                                                    }}
                                                    placeholder="e.g. 50100..."
                                                    className="text-sm border border-gray-200 rounded-lg px-3 py-2 focus:ring-1 focus:ring-blue-100 focus:border-blue-400 outline-none"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* --- ACTION BUTTONS --- */}
                            <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setParties({
                                            name: '',
                                            contactNumber: '',
                                            category: '',
                                            address: '',
                                            bankName: '',
                                            accountNumber: '',
                                            ifsc: ''
                                        });
                                        setModalOpen(false);
                                    }}
                                    className="px-5 py-2.5 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-6 py-2.5 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-black shadow-sm transition-all transform active:scale-95"
                                >
                                    Save Party
                                </button>
                            </div>

                        </form>
                    </Modal>
                )}
            </div>
        </div>
    );
}

export default PartyManagement;